export default __webpack_public_path__ + "static/media/loader-simulator.375b78e7.svg";